// https://developer.mozilla.org/en-US/docs/Web/API/WakeLockSentinel
import { useEffect } from 'react';
import { useEvent } from 'react-use';

let lock = null as WakeLockSentinel | null;
const isLocked = () => lock && !lock.released;

async function request() {
  if (!isLocked()) {
    lock = await navigator.wakeLock.request('screen');
  }
}

async function release() {
  if (isLocked()) {
    await lock?.release();
    lock = null;
  }
}

function useWakeLock(requestLock: boolean) {
  useEffect(() => {
    if (requestLock) {
      request();
    } else {
      release();
    }
  }, [requestLock]);

  useEvent('visibilitychange', () => {
    if (document.visibilityState === 'visible' && lock?.released) {
      request();
    }
  });
}

export default useWakeLock;
